// Generated by CoffeeScript 2.7.0
Vue.mixin({
  beforeCreate: function() {
    return this.itself = this;
  }
});
